/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function EModuleInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="contact"
              title="e-Module Details for Pre-Event Training"
              description={
                <>
                  <h4>Returning Officer Onboarding Program e-Modules</h4>
                  <br />
                  <ul style={{ paddingLeft: "40px" }}>
                    <li>1) <a href="https://share.articulate.com/KxQCA8J3wgRZDp6hbtB-a"> Respectful Workplace</a></li>

                    <li>2) <a href="https://share.articulate.com/MxLb9kCgPvZjLtK9C8-Ao">Occupational Health and Safety</a></li>

                    <li>3) <a href="https://share.articulate.com/RIMuq_YbPn93Kh1dY1z5_">Introduction to Business Continuity</a></li>

                    <li>4) <a href="https://share.articulate.com/xoE1Vod2xsbYw1RtZz3rm">Organizational Overview</a></li>

                    <li>5) <a href="https://share.articulate.com/00lb12DzXthB3uqTCTErT">Role of the Returning Officer</a></li>

                    <li>6) <a href="https://share.articulate.com/Zf1TTMJjVlmDMIwwdSWbq"> The Election Officer Liaison Role</a></li>

                    <li>7) <a href="https://share.articulate.com/fdwZTxlvuR0DCmQDtWr6s"> Introduction to Returning Officer Financial Administration</a></li>

                    <li>8) <a href="https://share.articulate.com/C0IWFw5UwmrhMMvlDR2n3"> Introduction to the Election Management System (EMS)</a></li>

                    <li>9) <a href="https://share.articulate.com/L6OIzp-WMaMpnWlJH28Uo"> Introduction to the List of Electors, Enumeration, and Revision</a></li>

                    <li>10) <a href="https://share.articulate.com/Lx7NIOyAOCkHZlK6drhpU">Introduction to Electoral Mapping and GIS</a></li>

                    <li>11) <a href="https://share.articulate.com/TkubG-tTnNAOkT0KoB_Z8">Introduction to the Election Period </a></li>

                    <li>12) <a href="https://share.articulate.com/IrmsfRM07GxlA0PRq4FHH">Introduction to Early Voting</a></li>

                    <li>13) <a href="https://share.articulate.com/2lbsV4Bs4pHRq6xDKNui4">Introduction to the Write-in Ballot Poll</a></li>

                    <li>14) <a href="https://share.articulate.com/P2AsGb4M3SqVb4htLgSfL">Introduction to Election Day </a></li>

                    <li>15) <a href="https://share.articulate.com/oLmQ9mEOmZPfdeYHN11C5">Introduction to the Voting Location Inspection Assignment </a></li>
                  </ul>
                  <br />

                  <h4>Pre-Event Program e-Modules</h4>
                  <br />

                  <ul style={{ paddingLeft: "40px" }}>
                    <li>16) <a href="https://share.articulate.com/14eXyMJvZUxI6lOaJTTrI">Election Call – Opening the Returning Office</a></li>

                    <li>17) <a href="https://share.articulate.com/3ZtpBgQnxT_OpMmkwrnVj">Escalation and Support Model</a></li>

                    <li>18) <a href="https://share.articulate.com/Pk2MwV7SlNXnKxQ16bamt">Deployment of Election Materials</a></li>

                    <li>19) <a href="https://share.articulate.com/6-jamXySxJxpT7QkxhdHe">Candidate Registrations and Nominations</a></li>

                    <li>20) <a href="https://share.articulate.com/EBDvLfskXVUtw4vJKqJ_9">Ballot Production and Distribution</a></li>

                    <li>21) <a href="https://share.articulate.com/NDNtL540oUNKzgZ8JVuS9"> Managing Revision Activities </a></li>

                    <li>22) <a href="https://share.articulate.com/fdzMLbN7OaseMi8fUpSTQ"> Managing the Write-in Ballot Poll </a></li>

                    <li>23) <a href="https://share.articulate.com/I17JeVtFlmhGHEjFxxN3_"> Location Confirmations and Voter Information Card (VIC) Production </a></li>

                    <li>24) <a href="https://share.articulate.com/5eauPL3FjODH7HH9SlFLA"> Entering Time Sheets and Expenses into EMS</a></li>

                    <li>25) <a href="https://share.articulate.com/yKHpDoM3wFpLVmPNlPJHH"> Approving, Processing and Submitting Payroll to ENS</a></li>

                    <li>26) <a href="https://share.articulate.com/WYNsxpGmz8cLw3udgit52"> Recruiting, Appointing and Training Election Workers </a></li>

                    <li>27) <a href="https://share.articulate.com/rGET0tnurUy_pmAUOWiIM"> Election Day</a></li>

                    {/* <li>28) Processing Voting Location Payments (combined with item 29)</li>

                    <li>29) Processing Election Day Payroll (combined with items 23, 24, and 26) </li> */}

                    <li>28) <a href="https://share.articulate.com/jLe_5VzLU55mt2QoVO1cw"> Other Post Event Activities and Closing the Office</a></li>

                    <li>29) <a href="https://share.articulate.com/FBA5XNp-3T2BoI0IjHs88#/"> Early Voting Procedures</a></li>

                    {/* <li>30) <a href="/files/e_module/COVID-19%20Precautions%20and%20Protocols%20for%20Returning%20Offices%20-%20Storyline%20output/story.html"> COVID-19 precautions and protocols for returning office staff</a></li>
                    <li>31) <a href=" /files/e_module/COVID%2019%20Precautions%20and%20Protocols%20for%20Election%20Workers%20-%20Storyline%20output/story.html"> COVID-19 precautions and protocols for election workers</a></li>
                     */}

                    <li>30) COVID-19 precautions and protocols for returning office staff</li>
                    <li>31) COVID-19 precautions and protocols for election workers</li>

                    <li>32) <a href="https://share.articulate.com/LyISy9rP_gmwdeoYBzvFp#/"> Introduction to the Returning Office Telephone System</a></li>
                    <li>33) <a href="https://share.articulate.com/Axq1lOZjTb8lLQV2qeI5i">Hospital Write-in Ballot Poll</a></li>
                  </ul>

                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default EModuleInformation;
